export const PROVIDER_CONNECTION_STATE = {
  READY: "ready",
  ENABLE_REQUIRED: "enable_required",
  CONNECTED: "connected",
  REAUTHENTICATION_REQUIRED: "reauthentication_required",
  DISCONNECTED: "disconnected",
};

export const getProviderConnectionState = (userDetails, provider) => {
  const providerId = provider?.provider_id;
  if (!providerId) {
    return PROVIDER_CONNECTION_STATE.DISCONNECTED;
  }

  const authState = userDetails?.provider_auth_state?.[providerId];
  if (authState === PROVIDER_CONNECTION_STATE.REAUTHENTICATION_REQUIRED) {
    return PROVIDER_CONNECTION_STATE.REAUTHENTICATION_REQUIRED;
  }

  if (authState === PROVIDER_CONNECTION_STATE.CONNECTED && userDetails?.identity_atoms?.[providerId]) {
    return PROVIDER_CONNECTION_STATE.CONNECTED;
  }

  if (provider.service_type === "native") {
    return provider.gluon_link_enabled === false
      ? PROVIDER_CONNECTION_STATE.READY
      : PROVIDER_CONNECTION_STATE.ENABLE_REQUIRED;
  }

  return PROVIDER_CONNECTION_STATE.DISCONNECTED;
};
